import api from '@/api'
import {
  SET_ACTIVITY_LIST,
  SET_ACTIVITY_LIST_PAGE_TOTAL,
  SET_ACTIVITY_LIST_PAGE_NUM,
  SET_ACTIVITY_LIST_PAGE_SIZE,
  SET_ACTIVITY_LIST_PAGE_QUERY,
  SET_ACTIVITY_LIST_SEARCHING,
} from './mutation-types'
import {objectTrim} from '@/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  activityName: '',
  creater: '',
  createStartTime: '',
  createEndTime: '',
  availabeStartTime: '',
  availabeEndTime: '',
  activityStatus: '',
})

const state = {
  searching: false,
  initQuery: initQuery(),
  activity: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_ACTIVITY_LIST] (state, payload) {
    state.activity.list = payload
  },
  [SET_ACTIVITY_LIST_PAGE_TOTAL] (state, payload) {
    state.activity.listPageTotal = payload
  },
  [SET_ACTIVITY_LIST_PAGE_NUM] (state, payload) {
    state.activity.query.pageNum = payload
  },
  [SET_ACTIVITY_LIST_PAGE_SIZE] (state, payload) {
    state.activity.query.pageSize = payload
  },
  [SET_ACTIVITY_LIST_PAGE_QUERY] (state, payload) {
    state.activity.query = {
      ...state.activity.query,
      ...payload,
    }
  },
  [SET_ACTIVITY_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
}

const actions = {
  async queryByCondition ({commit}) {
    try {
      let params = {
        ...objectTrim(state.activity.query, false, true),
      }
      const {data: {items, total}} = await api.deployApi.queryByCondition(params)
      commit(SET_ACTIVITY_LIST_SEARCHING, false)
      commit(SET_ACTIVITY_LIST, items)
      commit(SET_ACTIVITY_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_ACTIVITY_LIST_SEARCHING, false)
      commit(SET_ACTIVITY_LIST, [])
      commit(SET_ACTIVITY_LIST_PAGE_TOTAL, 0)
    }
  },
  // async updateList ({commit, dispatch}, {pageNum}) {
  //   commit('SET_ACTIVITY_LIST_PAGE_NUM', pageNum)
  //   await dispatch('queryByCondition')
  // },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_ACTIVITY_LIST_PAGE_NUM, payload)
    // dispatch('updateList', {pageNum: payload})
  },
  setPageSize ({commit, dispatch}, payload) {
    commit(SET_ACTIVITY_LIST_PAGE_NUM, 1)
    commit(SET_ACTIVITY_LIST_PAGE_SIZE, payload)
    // dispatch('updateList', {pageNum: 1})
  },
  setPageQuery ({commit, dispatch}, payload) {
    commit(SET_ACTIVITY_LIST_PAGE_QUERY, payload)
  },
  changeActivityQuery ({commit, dispatch}, payload) {
    commit(SET_ACTIVITY_LIST_SEARCHING, true)
    dispatch('queryByCondition')
  },
  async addActivity ({dispatch, state}, payload) {
    const data = await api.deployApi.insertActivities(payload)
    if (data.result && data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
  async updateActivity ({dispatch, state}, payload) {
    const data = await api.deployApi.updateActivities(payload)
    if (data.result && data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
  async delActivity ({dispatch, state}, payload) {
    const data = await api.deployApi.deleteActivities(payload)
    if (data.result && data.code === 200) {
      dispatch('queryByCondition')
    }
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
